import * as ActionType from '../../core/ActionType';
import { ApiCallBeginAction } from '../api/Action';
import { setErrorResponse } from '../responses/Action';
import { ProdutoService } from './Service';

/**
 * 
 * @param {Objeto completo contendo a lista de Produtos} produtoObject 
 */
export const getProdutosResponse = produtoObject => ({
    type: ActionType.GET_PRODUTO_RESPONSE,
    produtoObject
});


export function getProdutosFullAction() {
    return async function (dispatch) {
        await dispatch(setErrorResponse(null));
        dispatch(ApiCallBeginAction());
        
        try {
            let produtoObject = await ProdutoService.getProdutosFull()
            dispatch(getProdutosResponse(produtoObject));
        } catch (error) {
            dispatch(setErrorResponse(error));
        }
    };
}